import CustomTextInput from "components/CustomTextInput";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Col, Modal, Row } from "reactstrap";
import { Button } from "shared";
import "./index.scss";

type ModalAddRevenueProps = {
  open: boolean;
  toggle: () => void;
  onSave: (data: any) => void;
  selectedItem?: any;
};

const date = new Date();
const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);

const ModalAddRevenue = ({
  open,
  toggle,
  onSave,
  selectedItem,
}: ModalAddRevenueProps) => {
  const [data, setData] = useState({
    month_year: moment(firstDay).format("YYYY-MM-DD"),
    revenue_value: "",
  });
  const updateAtt = (att: string, value: any) => {
    setData({
      ...data,
      [att]: value,
    });
  };
  useEffect(() => {
    setData({
      month_year: selectedItem
        ? selectedItem.month_year_start_date
        : moment(firstDay).format("YYYY-MM-DD"),
      revenue_value: selectedItem?.revenue_value || "",
    });
  }, [selectedItem]);
  return (
    <Modal isOpen={open} toggle={toggle}>
      <div className="add-revenue__header">
        <span className="add-revenue__title">Add Revenue</span>
      </div>
      <div className="add-revenue__body">
        <Row>
          <Col sm={{ size: 6, offset: 0 }}>
            <CustomTextInput
              type="date"
              callback={updateAtt}
              data={data}
              labelText="Select date"
              attributeName="month_year"
              showMonthYearOnly
              dateFormat="yyyy-MM"
              disabled={!!selectedItem}
            />
          </Col>
          <Col sm={{ size: 6, offset: 0 }}>
            <CustomTextInput
              callback={updateAtt}
              data={data}
              labelText="Revenue"
              attributeName="revenue_value"
              isNumeric
            />
          </Col>
        </Row>
      </div>
      <div className="add-revenue__footer">
        <Button label="Cancel" onClick={toggle} />
        <div style={{ width: 10 }} />
        <Button label="Save" type="primary" onClick={() => onSave(data)} />
      </div>
    </Modal>
  );
};

export default ModalAddRevenue;
